var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMobileLogo)?_c('img',{staticClass:"mobile-logo",attrs:{"src":_vm.smexMobileLogo}}):_c('img',{staticClass:"logo",attrs:{"src":_vm.smexLogo}})}
var staticRenderFns = []
export { render, staticRenderFns }